import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSwitch.css';

const LANGUAGES = [
    { code: 'fr', label: 'FR', Flag: FlagFr },
    { code: 'en', label: 'EN', Flag: FlagGb },
];

function FlagFr() {
    return (
        <svg className="lang-switch__flag" viewBox="0 0 3 2" aria-hidden="true">
            <rect width="1" height="2" fill="#002395" />
            <rect x="1" width="1" height="2" fill="#fff" />
            <rect x="2" width="1" height="2" fill="#ED2939" />
        </svg>
    );
}

function FlagGb() {
    return (
        <svg className="lang-switch__flag" viewBox="0 0 60 30" aria-hidden="true">
            <clipPath id="lang-switch-gb-s">
                <path d="M0,0 v30 h60 v-30 z" />
            </clipPath>
            <clipPath id="lang-switch-gb-t">
                <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
            </clipPath>
            <g clipPath="url(#lang-switch-gb-s)">
                <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#lang-switch-gb-t)" stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </svg>
    );
}

const LanguageSwitch = () => {
    const { language, setLanguage } = useLanguage();
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const current = LANGUAGES.find((lang) => lang.code === language) || LANGUAGES[0];
    const CurrentFlag = current.Flag;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const handleSelect = (code) => {
        setLanguage(code);
        setOpen(false);
    };

    return (
        <div className={`lang-switch${open ? ' lang-switch--open' : ''}`} ref={rootRef}>
            <button
                type="button"
                className="lang-switch__trigger"
                onClick={() => setOpen((prev) => !prev)}
                aria-label="Changer la langue"
                aria-haspopup="listbox"
                aria-expanded={open}
            >
                <CurrentFlag />
                <span className="lang-switch__label">{current.label}</span>
                <span className="lang-switch__chevron" aria-hidden="true" />
            </button>
            {open && (
                <ul className="lang-switch__menu" role="listbox" aria-label="Langues">
                    {LANGUAGES.map(({ code, label, Flag }) => (
                        <li key={code} role="option" aria-selected={language === code}>
                            <button
                                type="button"
                                className={`lang-switch__option${language === code ? ' lang-switch__option--active' : ''}`}
                                onClick={() => handleSelect(code)}
                            >
                                <Flag />
                                <span>{label}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitch;
